import './Password.css'
import * as React from 'react'
import { Redirect } from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

class PasswordState {
    public password: string = ''
    public confirmPassword: string = ''
    public redirect: boolean = false
}

class Password extends React.Component<any, PasswordState> {
    private formRef: React.RefObject<HTMLFormElement>

    constructor(props: any) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this)
        this.formRef = React.createRef<HTMLFormElement>()
        this.onPasswordChange = this.onPasswordChange.bind(this)
        this.onConfirmPasswordChange = this.onConfirmPasswordChange.bind(this)
        this.state = new PasswordState()
    }

    public render() {
        let page
        if (this.state.redirect) {
            page = <Redirect to="/" />
        } else {
            page = <form className="Password" onSubmit={this.onSubmit} ref={this.formRef}>
                <label htmlFor="newPassword">New Password:</label><br />
                <input type="password" name="newPassword" onChange={this.onPasswordChange} required={true} value={this.state.password} /><br />
                <label htmlFor="confirmPassword">Confirm new Password:</label><br />
                <input type="password" name="confirmPassword" onChange={this.onConfirmPasswordChange} required={true} value={this.state.confirmPassword} /><br />
                <input type="submit" />
            </form>
        }
        return page
    }

    private onPasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ password: event.target.value })
    }

    private onConfirmPasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
        const cPassword = event.target.value
        if (this.state.password === cPassword) {
            event.target.setCustomValidity('')
        } else {
            event.target.setCustomValidity('Emails don\'t match')
        }
        this.setState({ confirmPassword: event.target.value })
    }

    private onSubmit(event: React.FormEvent) {
        event.preventDefault()
        if (this.formRef.current!.checkValidity()) {
            const user = firebase.auth().currentUser
            if (user !== null) {
                firebase.firestore().collection('users').doc(user.uid).update({ isConfirmed: true })
                    .then(r => {
                        return user.updatePassword(this.state.password)
                    })
                    .then(_ => {
                        this.setState({ redirect: true })
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}

export default Password


// WEBPACK FOOTER //
// ./src/components/password/Password.tsx